var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.$emit('remove-SKU', _vm.SKUItem)}}},[_c('p',[_vm._v(_vm._s(_vm.SKUItem))])])
}
var staticRenderFns = []

export { render, staticRenderFns }